module.exports = __webpack_public_path__ + "static/media/image-4.2e97c8ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/EmailSigs/image-4.png
// module id = 471
// module chunks = 0